import { defineComponent as J, computed as u, ref as k, watch as R, createElementBlock as d, openBlock as i, createElementVNode as p, createVNode as b, withCtx as C, createTextVNode as S, toDisplayString as g, Fragment as Y, renderList as L, createBlock as T, normalizeClass as A, renderSlot as K } from "vue";
import { _ as v } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import { _ as O } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Q = { class: "cal-nav-wrapper" }, W = {
  class: "cal-nav-bar",
  role: "toolbar",
  "aria-label": "Calendar navigation"
}, X = { class: "cal-nav-center" }, ee = {
  key: 0,
  class: "year-grid",
  role: "dialog",
  "aria-label": "Select year"
}, ae = { class: "year-grid-header" }, le = { class: "range-label" }, te = {
  class: "year-grid-body",
  role: "grid"
}, ne = {
  key: 1,
  class: "month-grid",
  role: "dialog",
  "aria-label": "Select month"
}, re = {
  class: "months",
  role: "grid"
}, se = {
  key: 2,
  class: "days-slot"
}, oe = /* @__PURE__ */ J({
  __name: "CalendarNavigationControl",
  props: {
    year: {},
    month: {},
    minYear: { default: 1970 },
    maxYear: { default: 2100 },
    yearSpan: { default: 12 },
    monthLabels: {},
    locale: { default: "en-US" },
    monthLabelStyle: { default: "short" },
    ariaPrevLabel: { default: "Previous" },
    ariaNextLabel: { default: "Next" },
    ariaToolbarLabel: { default: "Calendar navigation" },
    ariaSelectYearLabel: { default: "Select year" },
    ariaSelectMonthLabel: { default: "Select month" }
  },
  emits: ["update:year", "update:month", "mode-change", "year-selected", "month-selected"],
  setup(U, { emit: $ }) {
    const n = U, N = u(() => {
      if (n.monthLabels && n.monthLabels.length === 12) return n.monthLabels;
      const e = n.locale || "en-US", t = n.monthLabelStyle || "short", c = new Intl.DateTimeFormat(e, { month: t, timeZone: "UTC" });
      return Array.from({ length: 12 }, (_, H) => c.format(new Date(Date.UTC(2020, H, 1))));
    }), o = $, a = k(n.year), s = k(n.month);
    R(
      () => n.year,
      (e) => {
        e !== a.value && (a.value = e);
      }
    ), R(
      () => n.month,
      (e) => {
        e !== s.value && (s.value = e);
      }
    );
    const l = k("days");
    function m(e) {
      l.value !== e && (l.value = e, o("mode-change", e));
    }
    const y = u(() => n.minYear), f = u(() => n.maxYear), h = u(() => {
      const e = n.yearSpan;
      return a.value - a.value % e;
    }), x = u(() => h.value + n.yearSpan - 1);
    function P() {
      const e = n.yearSpan, t = h.value - e;
      t >= y.value && (a.value = t);
    }
    function w() {
      const e = n.yearSpan, t = h.value + e;
      t <= f.value && (a.value = t);
    }
    const D = u(() => h.value - n.yearSpan < y.value), M = u(() => x.value + n.yearSpan > f.value), B = u(() => {
      const e = n.yearSpan;
      return Math.ceil(e / 3);
    });
    function E(e) {
      const c = h.value + (e - 1) * 3;
      return Array.from({ length: 3 }, (r, _) => c + _).filter((r) => r <= x.value);
    }
    function V() {
      l.value === "months" ? m("days") : m("months");
    }
    function F() {
      l.value === "years" ? m("days") : m("years");
    }
    function I(e) {
      a.value = e, o("update:year", e), o("year-selected", e), m("months");
    }
    function z(e) {
      s.value = e, o("update:month", e), o("month-selected", e), m("days");
    }
    function Z() {
      if (l.value === "days") {
        let e = a.value, t = s.value - 1;
        if (t < 1 && (t = 12, e--), e < y.value) return;
        a.value = e, s.value = t, o("update:year", e), o("update:month", t);
      } else if (l.value === "months") {
        if (a.value - 1 < y.value) return;
        a.value--, o("update:year", a.value);
      } else l.value === "years" && P();
    }
    function j() {
      if (l.value === "days") {
        let e = a.value, t = s.value + 1;
        if (t > 12 && (t = 1, e++), e > f.value) return;
        a.value = e, s.value = t, o("update:year", e), o("update:month", t);
      } else if (l.value === "months") {
        if (a.value + 1 > f.value) return;
        a.value++, o("update:year", a.value);
      } else l.value === "years" && w();
    }
    const q = u(() => l.value === "days" ? a.value === y.value && s.value === 1 : l.value === "months" ? a.value - 1 < y.value : D.value), G = u(() => l.value === "days" ? a.value === f.value && s.value === 12 : l.value === "months" ? a.value + 1 > f.value : M.value);
    return (e, t) => (i(), d("div", Q, [
      p("div", W, [
        b(v, {
          type: "secondary",
          class: "cal-nav-btn prev",
          "aria-label": "Previous",
          disabled: q.value,
          onClick: Z,
          label: "",
          "prefix-icon": "ChevronLeft"
        }, null, 8, ["disabled"]),
        p("div", X, [
          b(v, {
            type: l.value === "months" ? "primary" : "secondary",
            "aria-pressed": l.value === "months",
            onClick: V
          }, {
            default: C(() => [
              S(g(N.value[s.value - 1]), 1)
            ]),
            _: 1
          }, 8, ["type", "aria-pressed"]),
          b(v, {
            type: l.value === "years" ? "primary" : "secondary",
            "aria-pressed": l.value === "years",
            onClick: F
          }, {
            default: C(() => [
              S(g(a.value), 1)
            ]),
            _: 1
          }, 8, ["type", "aria-pressed"])
        ]),
        b(v, {
          type: "secondary",
          class: "cal-nav-btn next",
          "aria-label": "Next",
          disabled: G.value,
          onClick: j,
          "prefix-icon": "ChevronRight",
          label: ""
        }, null, 8, ["disabled"])
      ]),
      l.value === "years" ? (i(), d("div", ee, [
        p("div", ae, [
          b(v, {
            type: "secondary",
            class: "cal-nav-btn prev",
            "aria-label": "Next",
            disabled: D.value,
            onClick: P,
            "prefix-icon": "AnglesRight",
            label: ""
          }, null, 8, ["disabled"]),
          p("div", le, g(h.value) + " - " + g(x.value), 1),
          b(v, {
            type: "secondary",
            class: "cal-nav-btn next",
            "aria-label": "Next",
            disabled: M.value,
            onClick: w,
            "prefix-icon": "AnglesRight",
            label: ""
          }, null, 8, ["disabled"])
        ]),
        p("div", te, [
          (i(!0), d(Y, null, L(B.value, (c) => (i(), d("div", {
            key: "yr-row-" + c,
            class: "year-grid-row",
            role: "row"
          }, [
            (i(!0), d(Y, null, L(E(c), (r) => (i(), T(v, {
              key: r,
              type: "secondary",
              class: A(["year-cell", { selected: r === a.value }]),
              role: "gridcell",
              disabled: r < y.value || r > f.value,
              onClick: (_) => I(r)
            }, {
              default: C(() => [
                S(g(r), 1)
              ]),
              _: 2
            }, 1032, ["class", "disabled", "onClick"]))), 128))
          ]))), 128))
        ])
      ])) : l.value === "months" ? (i(), d("div", ne, [
        p("div", re, [
          (i(!0), d(Y, null, L(N.value, (c, r) => (i(), T(v, {
            key: c,
            type: r + 1 === s.value ? "primary" : "secondary",
            class: A(["month-cell", { selected: r + 1 === s.value }]),
            role: "gridcell",
            onClick: (_) => z(r + 1)
          }, {
            default: C(() => [
              S(g(c), 1)
            ]),
            _: 2
          }, 1032, ["type", "class", "onClick"]))), 128))
        ])
      ])) : (i(), d("div", se, [
        K(e.$slots, "default", {
          year: a.value,
          month: s.value,
          mode: l.value
        }, void 0, !0)
      ]))
    ]));
  }
}), de = /* @__PURE__ */ O(oe, [["__scopeId", "data-v-196d6c6c"]]);
export {
  de as default
};
